(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["active-collection"] && !Shopify.designMode) return;
  try {
    
function initVavuCollectionSliders(scope=document){scope.querySelectorAll('[data-card-slider]').forEach(slider=>{if(slider.dataset.ready)return;slider.dataset.ready='true';const dots=[...slider.parentElement.querySelectorAll('[data-card-dot]')];const setActive=index=>dots.forEach((dot,i)=>dot.classList.toggle('is-active',i===index));let frame;slider.addEventListener('scroll',()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(()=>setActive(Math.round(slider.scrollLeft/slider.clientWidth)))});dots.forEach((dot,index)=>dot.addEventListener('click',event=>{event.preventDefault();event.stopPropagation();slider.scrollTo({left:index*slider.clientWidth,behavior:'smooth'})}))})}initVavuCollectionSliders();document.addEventListener('shopify:section:load',event=>initVavuCollectionSliders(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["active-header"] && !Shopify.designMode) return;
  try {
    
function initActiveHeader(root){if(root.dataset.ready)return;root.dataset.ready='true';const button=root.querySelector('.va-menu-button');const menu=root.querySelector('.va-mobile-menu');if(!button||!menu)return;const close=()=>{button.setAttribute('aria-expanded','false');menu.hidden=true};button.addEventListener('click',()=>{const open=button.getAttribute('aria-expanded')!=='true';button.setAttribute('aria-expanded',String(open));menu.hidden=!open});menu.addEventListener('click',e=>{if(e.target.closest('a'))close()});document.addEventListener('keydown',e=>{if(e.key==='Escape')close()});document.addEventListener('click',e=>{if(!root.contains(e.target))close()})}document.querySelectorAll('[data-active-header]').forEach(initActiveHeader);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-active-header]').forEach(initActiveHeader));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["active-home"] && !Shopify.designMode) return;
  try {
    
function initVavuCardSliders(scope=document){scope.querySelectorAll('[data-card-slider]').forEach(slider=>{if(slider.dataset.ready)return;slider.dataset.ready='true';const dots=[...slider.parentElement.querySelectorAll('[data-card-dot]')];const setActive=index=>dots.forEach((dot,i)=>dot.classList.toggle('is-active',i===index));let frame;slider.addEventListener('scroll',()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(()=>setActive(Math.round(slider.scrollLeft/slider.clientWidth)))});dots.forEach((dot,index)=>dot.addEventListener('click',event=>{event.preventDefault();event.stopPropagation();slider.scrollTo({left:index*slider.clientWidth,behavior:'smooth'})}))})}initVavuCardSliders();document.addEventListener('shopify:section:load',event=>initVavuCardSliders(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["active-product"] && !Shopify.designMode) return;
  try {
    
function initActiveProduct(root){if(root.dataset.ready)return;root.dataset.ready='true';const gallery=root.querySelector('.va-gallery-track');const slides=[...root.querySelectorAll('[data-gallery-slide]')];const dots=[...root.querySelectorAll('[data-gallery-dot]')];if(gallery&&slides.length>1){const goTo=index=>gallery.scrollTo({left:slides[index].offsetLeft,behavior:'smooth'});dots.forEach((dot,index)=>dot.addEventListener('click',()=>goTo(index)));const observer=new IntersectionObserver(entries=>{const visible=entries.filter(entry=>entry.isIntersecting).sort((a,b)=>b.intersectionRatio-a.intersectionRatio)[0];if(!visible)return;const index=slides.indexOf(visible.target);dots.forEach((dot,dotIndex)=>{dot.classList.toggle('is-active',dotIndex===index);if(dotIndex===index)dot.setAttribute('aria-current','true');else dot.removeAttribute('aria-current')})},{root:gallery,threshold:[.55,.75,.95]});slides.forEach(slide=>observer.observe(slide))}const data=root.querySelector('[data-product-json]');let variants=[];try{variants=JSON.parse(data?.textContent||'[]')}catch{}const radios=[...root.querySelectorAll('[data-option-position]')];const idInput=root.querySelector('[data-variant-id]');const price=root.querySelector('[data-price]');const button=root.querySelector('[data-add-button]');const money=amount=>new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:window.Shopify?.currency?.active||'USD'}).format(amount/100);const sync=()=>{const selected=[];radios.filter(r=>r.checked).forEach(r=>{selected[Number(r.dataset.optionPosition)-1]=r.value;const label=root.querySelector('[data-selected-option="'+r.dataset.optionPosition+'"]');if(label)label.textContent=r.value});const variant=variants.find(v=>v.options.every((value,index)=>value===selected[index]));if(!variant)return;if(idInput)idInput.value=variant.id;if(price)price.innerHTML='<span>'+money(variant.price)+'</span>'+(variant.compare_at_price&&variant.compare_at_price>variant.price?'<s>'+money(variant.compare_at_price)+'</s>':'');if(button){button.disabled=!variant.available;button.textContent=variant.available?'Add to cart':'Sold out'}};radios.forEach(r=>r.addEventListener('change',sync));const dialog=root.querySelector('[data-review-dialog]');if(dialog?.querySelector('.va-review-success'))dialog.showModal();root.querySelector('[data-review-open]')?.addEventListener('click',()=>dialog?.showModal());root.querySelectorAll('[data-review-close]').forEach(close=>close.addEventListener('click',()=>dialog?.close()))}document.querySelectorAll('[data-active-product]').forEach(initActiveProduct);document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-active-product]').forEach(initActiveProduct));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
